
// check if the environment variable is not "undefined" and is truthy
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const parseBoolean = (value: any, defaultValue: boolean): boolean => {
    if (typeof value === 'undefined') return defaultValue;
    if (typeof value === 'string') {
        const lowered = value.toLowerCase().trim();
        if (lowered === 'false' || lowered === '0' || lowered === '') return false;
        if (lowered === 'true' || lowered === '1') return true;
    }
    return !!value;
};

export const GA4_ID = import.meta.env.ANALYTICS_ID || 'G-DQP82Z38X5';

/**
 * Indicates whether the app is in development mode.
 */
export const DEV_MODE = import.meta.env.DEV;

export const APP_VERSION = import.meta.env.APP_VERSION;
